import {
  AdminResourcePermissionDictCreateRequest,
  AdminResourcePermissionDictCreateResponse,
  AdminResourcePermissionDictDeleteRequest,
  AdminResourcePermissionDictDeleteResponse,
  AdminResourcePermissionDictListRequest,
  AdminResourcePermissionDictListResponse,
  AdminResourcePermissionDictUpdateRequest,
  AdminResourcePermissionDictUpdateResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export default class ResourcePermissionsDictService {
  public list(request: AdminResourcePermissionDictListRequest): Promise<AxiosResponse<AdminResourcePermissionDictListResponse>> {
    return axios.post<AdminResourcePermissionDictListResponse>('/api/admin/resources/permissions/dict/list', request);
  }

  public create(request: AdminResourcePermissionDictCreateRequest): Promise<AxiosResponse<AdminResourcePermissionDictCreateResponse>> {
    return axios.post<AdminResourcePermissionDictCreateResponse>('/api/admin/resources/permissions/dict/create', request);
  }

  public update(request: AdminResourcePermissionDictUpdateRequest): Promise<AxiosResponse<AdminResourcePermissionDictUpdateResponse>> {
    return axios.post<AdminResourcePermissionDictUpdateResponse>('/api/admin/resources/permissions/dict/update', request);
  }

  public delete(request: AdminResourcePermissionDictDeleteRequest): Promise<AxiosResponse<AdminResourcePermissionDictDeleteResponse>> {
    return axios.post<AdminResourcePermissionDictDeleteResponse>('/api/admin/resources/permissions/dict/delete', request);
  }
}
